import { Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TCapturedCardTerminal = {
  primaryKey: string | number,
  dateAndTime: string,
  transactionNumber: string,
  cardNumber: string,
  reasonOfCapture: string,
};

type Props = {
  isLoading: boolean | undefined,
};

const columnHelper = createColumnHelper<TCapturedCardTerminal>();

export function getCapturedCardTerminalDataTableColumns({
  isLoading,
}: Props) {
  return [
    columnHelper.accessor('dateAndTime', {
      id: 'dateAndTime',
      header: 'Date & Time',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{!!props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('transactionNumber', {
      id: 'transactionNumber',
      header: 'Numéro Transaction',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('cardNumber', {
      id: 'cardNumber',
      header: 'Numéro de Carte',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('reasonOfCapture', {
      id: 'reasonOfCapture',
      header: 'Raison de la Capture',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
  ];
}
